import React from "react";
import smoothscroll from "smoothscroll-polyfill";
import Provider from "~/store";
import "~/assets/styles/index.scss";

smoothscroll.polyfill();

export const onRouteUpdate = () => {
}

export const wrapRootElement = ({ element }) => <Provider>{element}</Provider>;
